import { render, staticRenderFns } from "./formularios.vue?vue&type=template&id=63b730f8"
import script from "./formularios.vue?vue&type=script&lang=js"
export * from "./formularios.vue?vue&type=script&lang=js"
import style0 from "./formularios.vue?vue&type=style&index=0&id=63b730f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports